import React from "react";

import styles from "./styles.module.scss";

export interface Button<T> {
  label: string | React.ReactNode;
  value: T;
}

export interface ButtonGroupSwitcherProps<T> {
  title: string;
  buttons: Button<T>[];
  onClick?: (value: T) => void;
  isActive?: (item: Button<T>) => boolean;
  disabled?: boolean;
}

export const ButtonGroupSwitcher = <T extends any>(props: ButtonGroupSwitcherProps<T>) => {
  const { title, buttons } = props;

  const onClick = props.onClick ? props.onClick : undefined;
  const isActive = props.isActive ? props.isActive : () => false;
  const isDisabled = props.disabled ? props.disabled : false;

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{title}</div>
      <div className={styles.buttonsWrapper}>
        {buttons.map((button, idx) => (
          <button
            key={`button-group-${idx}`}
            aria-selected={isActive(button)}
            disabled={isDisabled}
            onClick={() => {
              onClick && onClick(button.value);
            }}
          >
            {button.label}
          </button>
        ))}
      </div>
    </div>
  );
};
